import React from "react";
import { image } from "./../../utils/constants";
import { Linkedin} from 'lucide-react';

export default function TopHeader() {
  return (
    <div className="w-full h-[55px] justify-center items-center bg-blue-900 hidden md:flex lg:flex">
      <div className="w-[98%] p-[20px] flex flex-row justify-center items-center gap-[20px]">
        <p className="text-[#fff] font-bold">Suivez nous : </p>
        <ul className="flex flex-row gap-y-5 py-8 gap-5">
          <li className="flex items-center gap-2">
            <img src={image.iconWhatsApp} alt="icon whatsapp" width={20} />
            <span className=" text-sm block text-white">
              <a href="https://wa.me/+237675147996">+237 675 147 996</a>
            </span>
          </li>
          <li className="flex items-center gap-2">
            <img src={image.iconEmail} alt="icon email" width={20} />
            <span className="break-words lg:break-normal text-white text-sm">
              <a href="mailto:contact@novengineering.com">
                contact@novengineering.com
              </a>
            </span>
          </li>
          <li className="flex items-center gap-2">
            <Linkedin color="white"/>
            <span className="break-words lg:break-normal text-white text-sm">
              <a href="https://www.linkedin.com/company/nove-engineering/">
                Nove Engineering
              </a>
            </span>
          </li>

        </ul>
      </div>
    </div>
  );
}
